import { gql } from '@apollo/client';
import type { DocumentNode } from 'graphql';

export type MedcallDiversionParticipantAlias = {
  firstname: string;
  lastname: string;
};

type MedcallDiversionParticipantAliasesData = {
  medcallDiversionParticipantAliases: MedcallDiversionParticipantAlias[];
};

type MedcallDiversionParticipantAliasesVariables = {
  diversionParticipantId: number;
  programKey: string;
};

type MedcallDiversionParticipantAliasQueryClient = {
  query: (options: {
    fetchPolicy: 'network-only';
    query: DocumentNode;
    variables: MedcallDiversionParticipantAliasesVariables;
  }) => Promise<{ data?: MedcallDiversionParticipantAliasesData }>;
};

export const MEDCALL_DIVERSION_PARTICIPANT_ALIASES = gql`
  query MedcallDiversionParticipantAliases($diversionParticipantId: Int!, $programKey: String!) {
    medcallDiversionParticipantAliases(
      diversionParticipantId: $diversionParticipantId
      programKey: $programKey
    ) {
      firstname
      lastname
    }
  }
`;

export const loadMedcall2DiversionParticipantAliases = async ({
  apolloClient,
  diversionParticipantId,
  programKey,
  routeBase,
}: {
  apolloClient: MedcallDiversionParticipantAliasQueryClient;
  diversionParticipantId: number;
  programKey: string;
  routeBase: string;
}) => {
  if (routeBase !== '/tools/medcall2') {
    return [];
  }

  const result = await apolloClient.query({
    fetchPolicy: 'network-only',
    query: MEDCALL_DIVERSION_PARTICIPANT_ALIASES,
    variables: {
      diversionParticipantId,
      programKey,
    },
  });

  return result.data?.medcallDiversionParticipantAliases || [];
};
